/* eslint-disable react/destructuring-assignment, react/prop-types */
import React, { useEffect } from 'react';
import {
  Route, Switch, Redirect, useParams, useLocation, useHistory,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import PrivateWrapper from '../PrivateWrapper';
import WrappedRoutes from './WrappedRoutes';
import Layout from '../../Layout/index';
import LogIn from '../../LogIn/index';
import InvestorLogin from '../../Investor/InvestorLogin';
import Distributions from '../../Investor/Distributions';
import InvestorStatements from '../../Investor/InvestorStatements';
import Planning from '../../Investor/Planning';
import News from '../../Investor/News';
import LiveFunds from '../../Investor/LiveFunds';
import AvailableSyndicationsFrame from '../../Investor/AvailableSyndicationsFrame';
import TrackingCookieConsent from '../../../shared/components/TrackingCookieConsent';
import Maintenance from '../../Maintenance';
import { AUTHENTICATION_COOKIE_QUERY_PARAM } from '../../../shared/services/authActions';

const GTM_TRACKING_ROUTES = new Set(['/available-funds', '/available-syndications']);

const RedirectToLogin = () => {
  window.location.replace('/login');
  return null;
};

const QcpRedirect = () => {
  const { urlSlug } = useParams();
  window.location.replace(`${process.env.AVG_API_PATH}/fund/${urlSlug}`);
  return null;
};

const Router = () => {
  const authType = useSelector((state) => state.auth.authType);
  const location = useLocation();
  const history = useHistory();
  const isMaintenanceRoute = location?.pathname?.toLowerCase().startsWith('/status');
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    if (queryParams.has(AUTHENTICATION_COOKIE_QUERY_PARAM)) {
      queryParams.delete(AUTHENTICATION_COOKIE_QUERY_PARAM);
      history.replace({
        search: queryParams.toString(),
      });
    }
  }, [history, location.search]);

  if (isMaintenanceRoute) {
    return (
      <main>
        <Maintenance />
      </main>
    );
  }

  return (
    <PrivateWrapper>
      <main>
        <div>
          <Layout />
          <TrackingCookieConsent
            shouldLoadGtmOnCurrentRoute={
              GTM_TRACKING_ROUTES.has(location.pathname) && authType !== 'MANAGED'
            }
          />
          <Switch>
            <Route exact path="/login" component={InvestorLogin} />
            <Route exact path="/sign-up" component={RedirectToLogin} />
            <Route exact path="/log_in" component={LogIn} />
            <Route exact path="/redirect">
              <Redirect to="/" />
            </Route>
            <Route path="/investment-in-progress/:urlSlug" component={QcpRedirect} />
            <Route exact path="/planning" component={Planning} />
            <Route exact path="/distributions" component={Distributions} />
            <Route exact path="/news" component={News} />
            <Route
              exact
              path="/available"
            >
              <Redirect to="/available-syndications" />
            </Route>
            <Route
              exact
              path="/available-syndications"
              render={() => (
                authType === 'MANAGED' ? <Redirect to="/managed" /> : <AvailableSyndicationsFrame />
              )}
            />
            <Route
              exact
              path="/available-funds"
              render={() => (
                authType === 'MANAGED' ? <Redirect to="/managed" /> : <LiveFunds />
              )}
            />
            <Route exact path="/funds/statements" component={InvestorStatements} />
            <Route path="/" component={WrappedRoutes} />
          </Switch>
        </div>
      </main>
    </PrivateWrapper>
  );
};

export default Router;
